<aside class="aside">
  @for (link of links; track trackLink($index, link)) {
    <a
      class="aside__link"
      [routerLink]="link.path"
      routerLinkActive="aside__link_active"
    >
      {{ link.title }}
    </a>
  }
</aside>
